/**
 * returns a promise that will resolve in the specified number of
 * milliseconds
 */
export function sleep(milliseconds = 0) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
}
/**
 * generates a random string guaranteed to start with an alpha
 * character, which makes it suitable for HTML `id` attribute
 */
export function randomid(length = 10) {
    let ret = String.fromCharCode(97 + Math.floor(Math.random() * 26));
    while (ret.length < length)
        ret += Math.random().toString(36).slice(2);
    return ret.slice(0, length);
}
/**
 * useful for checking for empty strings, though in modern javascript
 * optional chaining may be easier: if (!str?.trim().length) ...
 */
export function isBlank(str) {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    return !str || !str.trim || str.trim().length === 0;
}
/**
 * useful for checking for empty strings, though in modern javascript
 * optional chaining may be easier: if (str?.trim().length) ...
 */
export function isNotBlank(str) {
    return !isBlank(str);
}
/**
 * useful for chaining Array.filter(isTruthy).map when using typescript; the map
 * variable will no longer be marked as optional
 *
 * also see: isNotNull
 */
export function isTruthy(str) {
    return Boolean(str);
}
/**
 * undefined and null both treated as null
 */
export function isNull(obj) {
    return obj == null;
}
/**
 * undefined and null both treated as null
 */
export function isNotNull(obj) {
    return obj != null;
}
/**
 * only checks for valid syntax
 */
export function isEmail(email) {
    return !!email && /^[a-z0-9!#$%&'*+/=?^_‘{|}~-]+(\.[a-z0-9!#$%&'*+/=?^_‘{|}~-]+)*@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i.test(email);
}
export function optionalString(str) {
    return str == null ? undefined : String(str);
}
export function printIf(...args) {
    if (args.length === 1)
        return args[0] == null ? '' : String(args[0]);
    return args[0] && args[1] != null ? String(args[1]) : '';
}
export function roundTo(num, digits = 0) {
    const conversion = Math.pow(10, digits);
    return Math.round((num + Number.EPSILON) * conversion) / conversion;
}
export function bytesToHuman(bytes) {
    if (!bytes)
        return '0 bytes';
    const scales = [' bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const scale = Math.min(5, Math.floor(Math.log(bytes) / Math.log(1024)));
    return String(parseFloat((bytes / Math.pow(1024, scale)).toPrecision(3))) + scales[scale];
}
